import { Routes } from '@angular/router';
import { TwoColumnLayoutComponent } from './layouts/two-column/two-column.component';
import { authGuard } from './core/guards/auth.guard';
import { permissionsGuard } from './core/guards/permissions.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./pages/auth/callback/callback.component').then(m => m.AuthCallbackComponent)
  },
  {
    path: 'sin-acceso',
    loadComponent: () => import('./pages/auth/sin-acceso/sin-acceso.component').then(m => m.SinAccesoComponent)
  },
  {
    path: 'lockscreen',
    loadComponent: () => import('./pages/auth/lockscreen/lockscreen.component').then(m => m.LockscreenComponent)
  },
  {
    // Pantalla proyectada de ingresos del turno. Se abre en otra ventana desde Vista del turno (61)
    // y desde Control de Accesos (233); por eso va fuera del layout, sin menu. No lleva guardias:
    // tiene su propia sesion, que se renueva sola, y la pantalla avisa si falta la sesion o el
    // permiso. El API revisa los dos en cada peticion.
    path: 'asistencia/proyeccion',
    title: 'Proyección de ingresos',
    loadComponent: () => import('./pages/asistencia/proyeccion/proyeccion.component').then(m => m.ProyeccionComponent)
  },
  {
    path: '',
    component: TwoColumnLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        // Perfil de la propia cuenta: no lleva permiso de pantalla porque
        // cualquiera que entro al sistema puede ver sus datos.
        path: 'perfil',
        loadComponent: () => import('./pages/perfil/perfil.component').then(m => m.PerfilComponent)
      },      {
        path: 'posiciones',
        canActivate: [permissionsGuard],
        data: { optionId: 51 },
        loadComponent: () => import('./pages/posiciones/posiciones.component').then(m => m.PosicionesComponent)
      },
      {
        path: 'catalogos/divisiones',
        canActivate: [permissionsGuard],
        data: { optionId: 19 },
        loadComponent: () => import('./pages/catalogos/divisiones/divisiones.component').then(m => m.DivisionesComponent)
      },
      {
        path: 'catalogos/subdepartamentos',
        canActivate: [permissionsGuard],
        data: { optionId: 22 },
        loadComponent: () => import('./pages/catalogos/subdepartamentos/subdepartamentos.component').then(m => m.SubdepartamentosComponent)
      },
      {
        path: 'catalogos/proyectos',
        canActivate: [permissionsGuard],
        data: { optionId: 23 },
        loadComponent: () => import('./pages/catalogos/proyectos/proyectos.component').then(m => m.ProyectosComponent)
      },
      {
        path: 'catalogos/justificaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 52 },
        loadComponent: () => import('./pages/catalogos/justificaciones/justificaciones.component').then(m => m.JustificacionesComponent)
      },
      {
        path: 'catalogos/paros-tecnicos',
        canActivate: [permissionsGuard],
        data: { optionId: 54 },
        loadComponent: () => import('./pages/catalogos/paros-tecnicos/paros-tecnicos.component').then(m => m.ParosTecnicosComponent)
      },
      {
        path: 'catalogos/ramas',
        canActivate: [permissionsGuard],
        data: { optionId: 53 },
        loadComponent: () => import('./pages/catalogos/ramas/ramas.component').then(m => m.RamasComponent)
      },
      {
        path: 'catalogos/causas-bloqueo',
        canActivate: [permissionsGuard],
        data: { optionId: 55 },
        loadComponent: () => import('./pages/catalogos/causas-bloqueo/causas-bloqueo.component').then(m => m.CausasBloqueoComponent)
      },
      {
        path: 'catalogos/rotaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 56 },
        loadComponent: () => import('./pages/catalogos/rotaciones/rotaciones.component').then(m => m.RotacionesComponent)
      },
      {
        path: 'catalogos/relojes',
        canActivate: [permissionsGuard],
        data: { optionId: 58 },
        loadComponent: () => import('./pages/catalogos/relojes/relojes.component').then(m => m.RelojesComponent)
      },
      {
        path: 'catalogos/ciclos',
        canActivate: [permissionsGuard],
        data: { optionId: 59 },
        loadComponent: () => import('./pages/catalogos/ciclos/ciclos.component').then(m => m.CiclosComponent)
      },
      {
        path: 'catalogos/mov-historico-empleado',
        canActivate: [permissionsGuard],
        data: { optionId: 230 },
        loadComponent: () => import('./pages/catalogos/mov-historico-empleado/mov-historico-empleado.component').then(m => m.MovHistoricoEmpleadoComponent)
      },
      {
        path: 'catalogos/tareas',
        canActivate: [permissionsGuard],
        data: { optionId: 175 },
        loadComponent: () => import('./pages/catalogos/tareas/tareas.component').then(m => m.TareasComponent)
      },
      {
        path: 'catalogos/documentos-requeridos',
        canActivate: [permissionsGuard],
        data: { optionId: 215 },
        loadComponent: () => import('./pages/catalogos/documentos-requeridos/documentos-requeridos.component').then(m => m.DocumentosRequeridosComponent)
      },
      {
        path: 'catalogos/ubicaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 17 },
        loadComponent: () => import('./pages/catalogos/ubicaciones/ubicaciones.component').then(m => m.UbicacionesComponent)
      },
      {
        path: 'catalogos/areas',
        canActivate: [permissionsGuard],
        data: { optionId: 20 },
        loadComponent: () => import('./pages/catalogos/areas/areas.component').then(m => m.AreasComponent)
      },
      {
        path: 'catalogos/categorias',
        canActivate: [permissionsGuard],
        data: { optionId: 27 },
        loadComponent: () => import('./pages/catalogos/categorias/categorias.component').then(m => m.CategoriasComponent)
      },
      {
        path: 'catalogos/clasificaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 29 },
        loadComponent: () => import('./pages/catalogos/clasificaciones/clasificaciones.component').then(m => m.ClasificacionesComponent)
      },
      {
        path: 'catalogos/centros-costo',
        canActivate: [permissionsGuard],
        data: { optionId: 18 },
        loadComponent: () => import('./pages/catalogos/centros-costo/centros-costo.component').then(m => m.CentrosCostoComponent)
      },
      {
        path: 'catalogos/departamentos',
        canActivate: [permissionsGuard],
        data: { optionId: 21 },
        loadComponent: () => import('./pages/catalogos/departamentos/departamentos.component').then(m => m.DepartamentosComponent)
      },
      {
        path: 'catalogos/dias-festivos',
        canActivate: [permissionsGuard],
        data: { optionId: 33 },
        loadComponent: () => import('./pages/catalogos/dias-festivos/dias-festivos.component').then(m => m.DiasFestivosComponent)
      },
      {
        path: 'catalogos/niveles',
        canActivate: [permissionsGuard],
        data: { optionId: 28 },
        loadComponent: () => import('./pages/catalogos/niveles/niveles.component').then(m => m.NivelesComponent)
      },
      {
        path: 'catalogos/puestos',
        canActivate: [permissionsGuard],
        data: { optionId: 24 },
        loadComponent: () => import('./pages/catalogos/puestos/puestos.component').then(m => m.PuestosComponent)
      },
      {
        path: 'catalogos/tipos-movimiento',
        canActivate: [permissionsGuard],
        data: { optionId: 8 },
        loadComponent: () => import('./pages/catalogos/tipos-movimiento/tipos-movimiento.component').then(m => m.TiposMovimientoComponent)
      },
      {
        path: 'catalogos/roles',
        canActivate: [permissionsGuard],
        data: { optionId: 2 },
        loadComponent: () => import('./pages/catalogos/roles/roles.component').then(m => m.RolesComponent)
      },
      {
        path: 'seguridad/permisos-por-rol',
        canActivate: [permissionsGuard],
        data: { optionId: 3 },
        loadComponent: () => import('./pages/seguridad/permisos-por-rol/permisos-por-rol.component').then(m => m.PermisosPorRolComponent)
      },
      {
        path: 'capacitacion/competencias',
        canActivate: [permissionsGuard],
        data: { optionId: 181 },
        loadComponent: () => import('./pages/capacitacion/competencias/competencias.component').then(m => m.CompetenciasComponent)
      },
      {
        path: 'capacitacion/experiencias',
        canActivate: [permissionsGuard],
        data: { optionId: 182 },
        loadComponent: () => import('./pages/capacitacion/experiencias/experiencias.component').then(m => m.ExperienciasComponent)
      },
      {
        path: 'capacitacion/formaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 193 },
        loadComponent: () => import('./pages/capacitacion/formaciones/formaciones.component').then(m => m.FormacionesComponent)
      },
      {
        path: 'capacitacion/conocimientos',
        canActivate: [permissionsGuard],
        data: { optionId: 183 },
        loadComponent: () => import('./pages/capacitacion/conocimientos/conocimientos.component').then(m => m.ConocimientosComponent)
      },
      {
        path: 'capacitacion/niveles-capacitacion',
        canActivate: [permissionsGuard],
        data: { optionId: 184 },
        loadComponent: () => import('./pages/capacitacion/niveles-capacitacion/niveles-capacitacion.component').then(m => m.NivelesCapacitacionComponent)
      },
      {
        path: 'capacitacion/habilidades',
        canActivate: [permissionsGuard],
        data: { optionId: 185 },
        loadComponent: () => import('./pages/capacitacion/habilidades/habilidades.component').then(m => m.HabilidadesComponent)
      },
      {
        path: 'catalogos/factores',
        canActivate: [permissionsGuard],
        data: { optionId: 7 },
        loadComponent: () => import('./pages/catalogos/factores/factores.component').then(m => m.FactoresComponent)
      },
      {
        path: 'nomina/vales-despensa',
        canActivate: [permissionsGuard],
        data: { optionId: 161 },
        loadComponent: () => import('./pages/nomina/vales-despensa/vales-despensa.component').then(m => m.ValesDespensaComponent)
      },
      {
        path: 'asistencia/asistencia-empleado',
        canActivate: [permissionsGuard],
        data: { optionId: 64 },
        loadComponent: () => import('./pages/asistencia/asistencia-empleado/asistencia-empleado.component').then(m => m.AsistenciaEmpleadoComponent)
      },
      {
        path: 'nomina/periodos-nomina',
        canActivate: [permissionsGuard],
        data: { optionId: 34 },
        loadComponent: () => import('./pages/nomina/periodos-nomina/periodos-nomina.component').then(m => m.PeriodosNominaComponent)
      },
      {
        // Alias: el catalogo real vive en catalogos/periodos-pago; esta ruta
        // caia al wildcard "en-construccion" porque no existia.
        path: 'nomina/periodos-pago',
        redirectTo: 'catalogos/periodos-pago',
        pathMatch: 'full',
      },
      {
        path: 'seguridad/permisos-plantilla',
        canActivate: [permissionsGuard],
        data: { optionId: 210 },
        loadComponent: () => import('./pages/seguridad/permisos-plantilla/permisos-plantilla.component').then(m => m.PermisosPlantillaComponent)
      },
      {
        path: 'nomina/salario-garantia',
        canActivate: [permissionsGuard],
        data: { optionId: 174 },
        loadComponent: () => import('./pages/nomina/salario-garantia/salario-garantia.component').then(m => m.SalarioGarantiaComponent)
      },
      {
        path: 'organizacion/organigrama-alterno',
        canActivate: [permissionsGuard],
        data: { optionId: 217 },
        loadComponent: () => import('./pages/organizacion/organigrama-alterno/organigrama-alterno.component').then(m => m.OrganigramaAlternoComponent)
      },
      {
        path: 'asistencia/aplicar-presencia',
        canActivate: [permissionsGuard],
        data: { optionId: 171 },
        loadComponent: () => import('./pages/asistencia/aplicar-presencia/aplicar-presencia.component').then(m => m.AplicarPresenciaComponent)
      },
      {
        path: 'asistencia/bajas-automaticas',
        canActivate: [permissionsGuard],
        data: { optionId: 169 },
        loadComponent: () => import('./pages/asistencia/bajas-automaticas/bajas-automaticas.component').then(m => m.BajasAutomaticasComponent)
      },
      {
        path: 'asistencia/administracion-ausentismos',
        canActivate: [permissionsGuard],
        data: { optionId: 158 },
        loadComponent: () => import('./pages/asistencia/administracion-ausentismos/administracion-ausentismos.component').then(m => m.AdministracionAusentismosComponent)
      },
      {
        // optionId 231. El alta de la opcion la hace el API al arrancar
        // (sql/startup/149_permisos_opciones_asistencia_y_herramientas.sql). Con eso la
        // pantalla ya aparece en Seguridad > Permisos por Rol; mientras nadie le prenda
        // Leer a un rol, solo SUPER_ADMIN entra.
        path: 'asistencia/central',
        canActivate: [permissionsGuard],
        data: { optionId: 231 },
        loadComponent: () => import('./pages/asistencia/asistencia-central/asistencia-central.component').then(m => m.AsistenciaCentralComponent)
      },
      {
        // Mismo caso: optionId 232, sembrado por el mismo script (ver nota arriba).
        path: 'asistencia/gafetes-biometricos',
        canActivate: [permissionsGuard],
        data: { optionId: 232 },
        loadComponent: () => import('./pages/asistencia/gafetes-biometricos/gafetes-biometricos.component').then(m => m.GafetesBiometricosComponent)
      },
      {
        // Mismo caso: optionId 233, sembrado por el mismo script (ver nota arriba).
        path: 'asistencia/control-accesos',
        canActivate: [permissionsGuard],
        data: { optionId: 233 },
        loadComponent: () => import('./pages/asistencia/control-accesos/control-accesos.component').then(m => m.ControlAccesosComponent)
      },
      {
        // optionId 234. Misma alta que las tres de arriba, y ademas hereda los roles
        // que hoy tienen el Api (opcion 6): la pantalla solo descarga archivos.
        path: 'configuracion/herramientas',
        canActivate: [permissionsGuard],
        data: { optionId: 234 },
        loadComponent: () => import('./pages/configuracion/herramientas/herramientas.component').then(m => m.HerramientasComponent)
      },
      {
        path: 'asistencia/reporte-analisis-ausentismo',
        canActivate: [permissionsGuard],
        data: { optionId: 153 },
        loadComponent: () => import('./pages/asistencia/reporte-analisis-ausentismo/reporte-analisis-ausentismo.component').then(m => m.ReporteAnalisisAusentismoComponent)
      },
      {
        path: 'asistencia/kardex-mensual',
        canActivate: [permissionsGuard],
        data: { optionId: 154 },
        loadComponent: () => import('./pages/asistencia/kardex-mensual/kardex-mensual.component').then(m => m.KardexMensualComponent)
      },
      {
        path: 'asistencia/comparativo-ausentismos',
        canActivate: [permissionsGuard],
        data: { optionId: 155 },
        loadComponent: () => import('./pages/asistencia/comparativo-ausentismos/comparativo-ausentismos.component').then(m => m.ComparativoAusentismosComponent)
      },
      {
        path: 'procesos/control-75',
        canActivate: [permissionsGuard],
        data: { optionId: 166 },
        loadComponent: () => import('./pages/procesos/control-75/control-75.component').then(m => m.Control75Component)
      },
      {
        path: 'procesos/presupuesto-requisiciones',
        canActivate: [permissionsGuard],
        data: { optionId: 172 },
        loadComponent: () => import('./pages/procesos/presupuesto-requisiciones/presupuesto-requisiciones.component').then(m => m.PresupuestoRequisicionesComponent)
      },
      {
        path: 'empleados/directorio',
        canActivate: [permissionsGuard],
        data: { optionId: 45 },
        loadComponent: () => import('./pages/empleados/directorio-empleados/directorio-empleados.component').then(m => m.DirectorioEmpleadosComponent)
      },
      {
        path: 'procesos/control-tareas-division',
        canActivate: [permissionsGuard],
        data: { optionId: 203 },
        loadComponent: () => import('./pages/procesos/control-tareas-division/control-tareas-division.component').then(m => m.ControlTareasDivisionComponent)
      },
      {
        path: 'procesos/reportes-genericos',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/reportes-genericos/reportes-genericos.component').then(m => m.ReportesGenericosComponent)
      },
      {
        path: 'seguridad/bitacora',
        canActivate: [permissionsGuard],
        data: { optionId: 191 },
        loadComponent: () => import('./pages/seguridad/bitacora/bitacora.component').then(m => m.BitacoraComponent)
      },
      {
        path: 'seguridad/directrices-seguridad',
        canActivate: [permissionsGuard],
        data: { optionId: 242 },
        loadComponent: () => import('./pages/seguridad/directrices-seguridad/directrices-seguridad.component').then(m => m.DirectricesSeguridadComponent)
      },
      {
        path: 'seguridad/desbloquear-usuarios',
        canActivate: [permissionsGuard],
        data: { optionId: 243 },
        loadComponent: () => import('./pages/seguridad/desbloquear-usuarios/desbloquear-usuarios.component').then(m => m.DesbloquearUsuariosComponent)
      },
      {
        path: 'empleados/movimientos',
        canActivate: [permissionsGuard],
        data: { optionId: 167 },
        loadComponent: () => import('./pages/empleados/movimientos-personal/movimientos-personal.component').then(m => m.MovimientosPersonalComponent)
      },
      {
        path: 'empleados/autorizantes-moper',
        canActivate: [permissionsGuard],
        data: { optionId: 244 },
        loadComponent: () => import('./pages/empleados/autorizantes-moper/autorizantes-moper.component').then(m => m.AutorizantesMoperComponent)
      },
      {
        path: 'organizacion/organigrama',
        canActivate: [permissionsGuard],
        data: { optionId: 162 },
        loadComponent: () => import('./pages/organizacion/organigrama/organigrama.component').then(m => m.OrganigramaComponent)
      },
      {
        path: 'organizacion/config-organigramas',
        canActivate: [permissionsGuard],
        data: { optionId: 163 },
        loadComponent: () => import('./pages/organizacion/config-organigramas/config-organigramas.component').then(m => m.ConfigOrganigramasComponent)
      },
      {
        path: 'nomina/procesos-nomina',
        canActivate: [permissionsGuard],
        data: { optionId: 165 },
        loadComponent: () => import('./pages/nomina/procesos-nomina/procesos-nomina.component').then(m => m.ProcesosNominaComponent)
      },
      {
        path: 'nomina/config-procesos',
        canActivate: [permissionsGuard],
        data: { optionId: 165 },
        loadComponent: () => import('./pages/nomina/config-procesos/config-procesos.component').then(m => m.ConfigProcesosComponent)
      },
      {
        path: 'nomina/prima-produccion',
        canActivate: [permissionsGuard],
        data: { optionId: 214 },
        loadComponent: () => import('./pages/nomina/prima-produccion/prima-produccion.component').then(m => m.PrimaProduccionComponent)
      },
      {
        // Roles de Destajo Azúcar (config singleton por razón social activa).
        // Opción 235 sembrada por sql/startup/178_destajo_azucar_e2e.sql.
        path: 'nomina/roles-destajo-azucar',
        canActivate: [permissionsGuard],
        data: { optionId: 235 },
        loadComponent: () => import('./pages/catalogos/roles-destajo-azucar/roles-destajo-azucar.component').then(m => m.RolesDestajoAzucarComponent)
      },
      {
        path: 'asistencia/presencia',
        canActivate: [permissionsGuard],
        data: { optionId: 160 },
        loadComponent: () => import('./pages/asistencia/presencia/presencia.component').then(m => m.PresenciaComponent)
      },
      {
        path: 'nomina/finiquitos',
        canActivate: [permissionsGuard],
        data: { optionId: 213 },
        loadComponent: () => import('./pages/nomina/finiquitos/finiquitos.component').then(m => m.FiniquitosComponent)
      },
      {
        path: 'asistencia/vista-turno',
        canActivate: [permissionsGuard],
        data: { optionId: 61 },
        loadComponent: () => import('./pages/asistencia/vista-turno/vista-turno.component').then(m => m.VistaTurnoComponent)
      },
      {
        path: 'asistencia/dashboard-asistencias',
        canActivate: [permissionsGuard],
        data: { optionId: 194 },
        loadComponent: () => import('./pages/asistencia/dashboard-asistencias/dashboard-asistencias.component').then(m => m.DashboardAsistenciasComponent)
      },
      {
        path: 'asistencia/posiciones-cubiertas',
        canActivate: [permissionsGuard],
        data: { optionId: 13 },
        loadComponent: () => import('./pages/asistencia/posiciones-cubiertas/posiciones-cubiertas.component').then(m => m.PosicionesCubiertasComponent)
      },
      {
        path: 'procesos/presupuesto-variables',
        canActivate: [permissionsGuard],
        data: { optionId: 173 },
        loadComponent: () => import('./pages/procesos/presupuesto-variables/presupuesto-variables.component').then(m => m.PresupuestoVariablesComponent)
      },
      {
        path: 'asistencia/informacion-sua',
        canActivate: [permissionsGuard],
        data: { optionId: 170 },
        loadComponent: () => import('./pages/asistencia/informacion-sua/informacion-sua.component').then(m => m.InformacionSuaComponent)
      },
      {
        path: 'nomina/cierre-semanal',
        canActivate: [permissionsGuard],
        data: { optionId: 216 },
        loadComponent: () => import('./pages/nomina/cierre-semanal/cierre-semanal.component').then(m => m.CierreSemanalComponent)
      },
      {
        path: 'plantilla/plantilla-personal',
        canActivate: [permissionsGuard],
        data: { optionId: 50 },
        loadComponent: () => import('./pages/plantilla/plantilla-personal/plantilla-personal.component').then(m => m.PlantillaPersonalComponent)
      },
      {
        path: 'plantilla/posiciones-extras',
        canActivate: [permissionsGuard],
        data: { optionId: 57 },
        loadComponent: () => import('./pages/plantilla/posiciones-extras/posiciones-extras.component').then(m => m.PosicionesExtrasComponent)
      },
      {
        path: 'empleados/escalafon',
        canActivate: [permissionsGuard],
        data: { optionId: 63 },
        loadComponent: () => import('./pages/empleados/escalafon/escalafon.component').then(m => m.EscalafonComponent)
      },
      {
        path: 'contratistas/contratos',
        canActivate: [permissionsGuard],
        data: { optionId: 178 },
        loadComponent: () => import('./pages/contratistas/contratos/contratos.component').then(m => m.ContratosComponent)
      },
      {
        path: 'nomina/variables-nomina',
        canActivate: [permissionsGuard],
        data: { optionId: 62 },
        loadComponent: () => import('./pages/nomina/variables-nomina/variables-nomina.component').then(m => m.VariablesNominaComponent)
      },
      {
        path: 'plantilla/estructura-eventuales',
        canActivate: [permissionsGuard],
        data: { optionId: 10 },
        loadComponent: () => import('./pages/plantilla/estructura-eventuales/estructura-eventuales.component').then(m => m.EstructuraEventualesComponent)
      },
      {
        path: 'catalogos/presupuesto-tareas',
        canActivate: [permissionsGuard],
        data: { optionId: 190 },
        loadComponent: () => import('./pages/catalogos/presupuesto-tareas/presupuesto-tareas.component').then(m => m.PresupuestoTareasComponent)
      },
      {
        path: 'catalogos/factores-prestaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 156 },
        loadComponent: () => import('./pages/catalogos/factores-prestaciones/factores-prestaciones.component').then(m => m.FactoresPrestacionesComponent)
      },
      {
        path: 'catalogos/prestaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 32 },
        loadComponent: () => import('./pages/catalogos/prestaciones/prestaciones.component').then(m => m.PrestacionesComponent)
      },
      {
        path: 'catalogos/prioridad-conceptos',
        canActivate: [permissionsGuard],
        data: { optionId: 13 },
        loadComponent: () => import('./pages/catalogos/prioridad-conceptos/prioridad-conceptos.component').then(m => m.PrioridadConceptosComponent)
      },
      {
        path: 'catalogos/config-clasificacion',
        canActivate: [permissionsGuard],
        data: { optionId: 157 },
        loadComponent: () => import('./pages/catalogos/config-clasificacion/config-clasificacion.component').then(m => m.ConfigClasificacionComponent)
      },
      {
        path: 'catalogos/registros-patronales',
        canActivate: [permissionsGuard],
        data: { optionId: 31 },
        loadComponent: () => import('./pages/catalogos/registros-patronales/registros-patronales.component').then(m => m.RegistrosPatronalesComponent)
      },
      {
        path: 'catalogos/config-correo',
        canActivate: [permissionsGuard],
        data: { optionId: 192 },
        loadComponent: () => import('./pages/catalogos/config-correo/config-correo.component').then(m => m.ConfigCorreoComponent)
      },
      {
        // Configuracion de la Aplicacion (config global singleton) — reemplaza la ruta legacy
        // ApplicationSetting/Setting del sistema de referencia. Opcion 5 «Aplicación» del grupo
        // Settings: sin ella la guardia dejaba pasar a cualquier rol y el menu la pintaba para todos.
        path: 'catalogos/config-aplicacion',
        canActivate: [permissionsGuard],
        data: { optionId: 5 },
        loadComponent: () => import('./pages/catalogos/config-aplicacion/config-aplicacion.component').then(m => m.ConfigAplicacionComponent)
      },
      {
        path: 'catalogos/periodos-pago',
        canActivate: [permissionsGuard],
        data: { optionId: 25 },
        loadComponent: () => import('./pages/catalogos/periodos-pago/periodos-pago.component').then(m => m.PeriodosPagoComponent)
      },
      {
        path: 'catalogos/roles-turno',
        canActivate: [permissionsGuard],
        data: { optionId: 26 },
        loadComponent: () => import('./pages/catalogos/roles-turno/roles-turno.component').then(m => m.RolesTurnoComponent)
      },
      {
        path: 'empresa/sucursales',
        canActivate: [permissionsGuard],
        data: { optionId: 16 },
        loadComponent: () => import('./pages/empresa/sucursales/sucursales.component').then(m => m.SucursalesComponent)
      },
      {
        path: 'contratistas/contratistas',
        canActivate: [permissionsGuard],
        data: { optionId: 177 },
        loadComponent: () => import('./pages/contratistas/contratistas/contratistas.component').then(m => m.ContratistasComponent)
      },
      {
        path: 'contratistas/empleados-contratistas',
        canActivate: [permissionsGuard],
        data: { optionId: 176 },
        loadComponent: () => import('./pages/contratistas/empleados-contratistas/empleados-contratistas.component').then(m => m.EmpleadosContratistasComponent)
      },
      {
        path: 'catalogos/horarios',
        canActivate: [permissionsGuard],
        data: { optionId: 30 },
        loadComponent: () => import('./pages/catalogos/horarios/horarios.component').then(m => m.HorariosComponent)
      },
      {
        path: 'catalogos/faltas',
        canActivate: [permissionsGuard],
        data: { optionId: 9 },
        loadComponent: () => import('./pages/catalogos/faltas/faltas.component').then(m => m.FaltasComponent)
      },
      {
        path: 'catalogos/conceptos-pago',
        canActivate: [permissionsGuard],
        data: { optionId: 12 },
        loadComponent: () => import('./pages/catalogos/conceptos-pago/conceptos-pago.component').then(m => m.ConceptosPagoComponent)
      },
      {
        path: 'catalogos/config-api',
        canActivate: [permissionsGuard],
        data: { optionId: 6 },
        loadComponent: () => import('./pages/catalogos/config-api/config-api.component').then(m => m.ConfigApiComponent)
      },
      {
        path: 'catalogos/config-ausentismo',
        canActivate: [permissionsGuard],
        data: { optionId: 152 },
        loadComponent: () => import('./pages/catalogos/config-ausentismo/config-ausentismo.component').then(m => m.ConfigAusentismoComponent)
      },
      {
        path: 'catalogos/detalle-faltas',
        canActivate: [permissionsGuard],
        data: { optionId: 150 },
        loadComponent: () => import('./pages/catalogos/detalle-faltas/detalle-faltas.component').then(m => m.DetalleFaltasComponent)
      },
      {
        path: 'capacitacion/dashboard',
        canActivate: [permissionsGuard],
        data: { optionId: 187 },
        loadComponent: () => import('./pages/capacitacion/dashboard/capacitacion-dashboard.component').then(m => m.CapacitacionDashboardComponent)
      },
      {
        path: 'capacitacion/capacitaciones',
        canActivate: [permissionsGuard],
        data: { optionId: 187 },
        loadComponent: () => import('./pages/capacitacion/capacitaciones/capacitaciones.component').then(m => m.CapacitacionesComponent)
      },
      {
        path: 'capacitacion/perfiles-puestos',
        canActivate: [permissionsGuard],
        data: { optionId: 179 },
        loadComponent: () => import('./pages/capacitacion/perfiles-puestos/perfiles-puestos.component').then(m => m.PerfilesPuestosComponent)
      },
      {
        path: 'empresa/empresa',
        canActivate: [permissionsGuard],
        data: { optionId: 15 },
        loadComponent: () => import('./pages/empresa/empresa/empresa.component').then(m => m.EmpresaComponent)
      },
      {
        path: 'seguridad/usuarios',
        canActivate: [permissionsGuard],
        data: { optionId: 1 },
        loadComponent: () => import('./pages/seguridad/usuarios/usuarios.component').then(m => m.UsuariosComponent)
      },
      {
        path: 'seguridad/seguridad-usuarios',
        canActivate: [permissionsGuard],
        data: { optionId: 186 },
        loadComponent: () => import('./pages/seguridad/seguridad-usuarios/seguridad-usuarios.component').then(m => m.SeguridadUsuariosComponent)
      },
      {
        path: 'variables/permisos-variables',
        canActivate: [permissionsGuard],
        data: { optionId: 65 },
        loadComponent: () => import('./pages/variables/permisos-variables/permisos-variables.component').then(m => m.PermisosVariablesComponent)
      },
      {
        path: 'convenios/convenios',
        canActivate: [permissionsGuard],
        data: { optionId: 204 },
        loadComponent: () => import('./pages/convenios/convenios/convenios.component').then(m => m.ConveniosComponent)
      },
      {
        path: 'convenios/convenios/:id/reporte',
        canActivate: [permissionsGuard],
        data: { optionId: 204 },
        loadComponent: () => import('./pages/convenios/convenio-reporte/convenio-reporte.component').then(m => m.ConvenioReporteComponent)
      },
      {
        path: 'procesos/presupuesto-proyectos',
        canActivate: [permissionsGuard],
        data: { optionId: 172 },
        loadComponent: () => import('./pages/procesos/presupuesto-proyectos/presupuesto-proyectos.component').then(m => m.PresupuestoProyectosComponent)
      },
      {
        path: 'procesos/variables-departamento',
        canActivate: [permissionsGuard],
        data: { optionId: 173 },
        loadComponent: () => import('./pages/procesos/variables-departamento/variables-departamento.component').then(m => m.VariablesDepartamentoComponent)
      },
      {
        path: 'nomina/calculo-procesos',
        canActivate: [permissionsGuard],
        data: { optionId: 165 },
        loadComponent: () => import('./pages/nomina/calculo-procesos/calculo-procesos.component').then(m => m.CalculoProcesosComponent)
      },
      {
        path: 'nomina/descarga-conceptos',
        canActivate: [permissionsGuard],
        data: { optionId: 165 },
        loadComponent: () => import('./pages/nomina/descarga-conceptos/descarga-conceptos.component').then(m => m.DescargaConceptosComponent)
      },
      {
        path: 'procesos/carta-no-adeudo',
        canActivate: [permissionsGuard],
        data: { optionId: 236 },
        loadComponent: () => import('./pages/procesos/carta-no-adeudo/carta-no-adeudo.component').then(m => m.CartaNoAdeudoComponent)
      },
      {
        path: 'procesos/carta-renuncia',
        canActivate: [permissionsGuard],
        data: { optionId: 237 },
        loadComponent: () => import('./pages/procesos/carta-renuncia/carta-renuncia.component').then(m => m.CartaRenunciaComponent)
      },
      {
        path: 'procesos/requisicion-personal',
        canActivate: [permissionsGuard],
        data: { optionId: 238 },
        loadComponent: () => import('./pages/procesos/requisicion-personal/requisicion-personal.component').then(m => m.RequisicionPersonalComponent)
      },
      {
        path: 'procesos/contrato-personal',
        canActivate: [permissionsGuard],
        data: { optionId: 239 },
        loadComponent: () => import('./pages/procesos/contrato-personal/contrato-personal.component').then(m => m.ContratoPersonalComponent)
      },
      {
        path: 'procesos/reporte-costeo',
        canActivate: [permissionsGuard],
        data: { optionId: 240 },
        loadComponent: () => import('./pages/procesos/reporte-costeo/reporte-costeo.component').then(m => m.ReporteCosteoComponent)
      },
      {
        path: 'procesos/disenador-reportes',
        canActivate: [permissionsGuard],
        data: { optionId: 241 },
        loadComponent: () => import('./pages/procesos/disenador-reportes/disenador-reportes.component').then(m => m.DisenadorReportesComponent)
      },
      {
        path: 'procesos/reporte-asistencia',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/reporte-asistencia/reporte-asistencia.component').then(m => m.ReporteAsistenciaComponent)
      },
      {
        path: 'procesos/reporte-plantilla',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/reporte-plantilla/reporte-plantilla.component').then(m => m.ReportePlantillaComponent)
      },
      {
        path: 'procesos/reporte-especial',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/reporte-especial/reporte-especial.component').then(m => m.ReporteEspecialComponent)
      },
      {
        path: 'procesos/jornadas-plantilla',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/jornadas-plantilla/jornadas-plantilla.component').then(m => m.JornadasPlantillaComponent)
      },
      {
        path: 'procesos/jornadas-categoria',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/jornadas-categoria/jornadas-categoria.component').then(m => m.JornadasCategoriaComponent)
      },
      {
        path: 'procesos/comparativo-dashboard',
        canActivate: [permissionsGuard],
        data: { optionId: 159 },
        loadComponent: () => import('./pages/procesos/comparativo-dashboard/comparativo-dashboard.component').then(m => m.ComparativoDashboardComponent)
      },
      {
        path: 'controles/dashboard-ppto-extra',
        canActivate: [permissionsGuard],
        data: { optionId: 172 },
        loadComponent: () => import('./pages/controles/dashboard-ppto-extra/dashboard-ppto-extra.component').then(m => m.DashboardPptoExtraComponent)
      },
      {
        path: 'controles/dashboard-ppto-proyectos',
        canActivate: [permissionsGuard],
        data: { optionId: 172 },
        loadComponent: () => import('./pages/controles/dashboard-ppto-proyectos/dashboard-ppto-proyectos.component').then(m => m.DashboardPptoProyectosComponent)
      },
      {
        path: 'controles/dashboard-variables',
        canActivate: [permissionsGuard],
        data: { optionId: 173 },
        loadComponent: () => import('./pages/controles/dashboard-variables/dashboard-variables.component').then(m => m.DashboardVariablesComponent)
      },
      {
        path: 'controles/dashboard-variables-depto',
        canActivate: [permissionsGuard],
        data: { optionId: 173 },
        loadComponent: () => import('./pages/controles/dashboard-variables-depto/dashboard-variables-depto.component').then(m => m.DashboardVariablesDeptoComponent)
      },
      {
        // Destino de permissionsGuard cuando el rol no tiene Leer en la opcion de la pantalla.
        path: 'acceso-denegado',
        loadComponent: () => import('./pages/acceso-denegado/acceso-denegado.component').then(m => m.AccesoDenegadoComponent)
      },
      {
        path: 'en-construccion',
        loadComponent: () => import('./pages/en-construccion/en-construccion.component').then(m => m.EnConstruccionComponent)
      },
      // Rutas no migradas (placeholders del menú que aún apuntan al sistema de referencia) y cualquier ruta inválida
      // muestran la página "En construcción" en vez de lanzar NG04002.
      { path: '**', redirectTo: 'en-construccion' }
    ]
  }
];
